import {Link} from "@inertiajs/react";
import {ReactNode} from "react";

interface Props {
    href: string;
    className?: string;
    children: ReactNode;
}
export default function PrimaryLink({href, className, children}: Props) {
    return (
        <Link
            href={href}
            className={`w-full bg-green-400 text-gray-900 p-2 text-base font-semibold rounded text-center flex gap-x-2 stroke-gray-900 items-center justify-center ${className ?? ''}`}
        >
            {children}
        </Link>
    )
}
